import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MessageService, SelectItem } from 'primeng';
import { Observable, Subscription } from 'rxjs';
import { LoggerService } from 'src/app/services';
import {
  IOrganisationSpecificStepGroup,
  IOrganisationSpecificSteps,
} from '../../../interfaces/organisation-specific-steps';
import { OrganisationSpecificStepsService } from '../../../services';
import { TaskTypeService } from '../../../services';
import { CustomerService } from '../../../services';
import { ICustomer } from '../../../interfaces/customer';

@Component({
  selector: 'app-organisation-specific-step-customers',
  templateUrl: './organisation-specific-step-customers.component.html',
  styleUrls: ['./organisation-specific-step-customers.component.scss'],
})
export class OrganisationSpecificStepCustomersComponent implements OnInit, OnDestroy {
  private selectedChecklistChangeSubscription: Subscription;
  @Input() selectedChecklistEvent: Observable<IOrganisationSpecificStepGroup>;

  private stepListChangeSubscription: Subscription;
  @Input() stepListChangedEvent: Observable<IOrganisationSpecificSteps[]>;

  public _isLocked: boolean;
  @Input()
  get isLocked(): boolean {
    return this._isLocked;
  }
  set isLocked(value: boolean) {
    if (value) {
      this._isLocked = value;
    }
  }

  public selectedChecklist: IOrganisationSpecificStepGroup;
  customersUsing: ICustomer[] = [];
  customersNotUsing: ICustomer[] = [];
  customersWereUsing: ICustomer[] = [];

  constructor(
    private taskTypeService: TaskTypeService,
    private organisationSpecificStepService: OrganisationSpecificStepsService,
    private messageService: MessageService,
    private customerService: CustomerService,
    private loggerService: LoggerService,
  ) {}

  ngOnInit() {
    this.loadChecklistCustomers();

    this.selectedChecklistChangeSubscription = this.selectedChecklistEvent.subscribe(
      (checklist) => {
        console.log('CHECKLIST CHANGE', checklist);

        if (checklist) {
          this.selectedChecklist = checklist;
          this.loadChecklistCustomers();

          if (
            this.selectedChecklist.steps == null ||
            (this.selectedChecklist.steps.length < 1 && this.selectedChecklist.id)
          ) {
            // nothing was assigned from the parent

            this.organisationSpecificStepService
              .getChecklistSteps(this.selectedChecklist.id)
              .then((res) => {
                if (res) {
                  this.selectedChecklist.steps = res;
                }
              });
          }
        }
      },
    );
  }

  ngOnDestroy() {}

  loadChecklistCustomers() {
    console.log('RUNNING LOAD');

    if (this.selectedChecklist == null) {
      this.customersUsing = [];
      this.customersNotUsing = [];
    } else {
      this.customerService.loadChecklistCustomers(this.selectedChecklist).then((results) => {
        this.customersUsing = results
          .filter(
            (x) => x.organisationSpecificStepsGroups.filter((x) => x.locked == true).length > 0,
          )
          .sort((a, b) => (a.name > b.name ? 1 : -1));
        this.customersWereUsing = results
          .filter(
            (x) => x.organisationSpecificStepsGroups.filter((x) => x.locked == false).length > 0,
          )
          .sort((a, b) => (a.name > b.name ? 1 : -1));
        this.customersNotUsing = results
          .filter((x) => x.organisationSpecificStepsGroups.length == 0)
          .sort((a, b) => (a.name > b.name ? 1 : -1));
      });
    }
  }

  applyStepGroup(item) {
    const customerId = item.id;

    this.customersUsing.push(item);
    this.customersUsing = [...this.customersUsing.sort((a, b) => (a.name > b.name ? 1 : -1))]; // Dereference it to trigger update
    this.customersNotUsing = this.customersNotUsing.filter((x) => x.id != item.id);

    this.organisationSpecificStepService
      .createChecklistClone(this.selectedChecklist, customerId)
      .then((x) => {
        console.log('SUCCESS: ', x);
      })
      .catch((y) => {
        console.log('ERROR: ', y);
      });
  }

  removeStepGroup(item) {
    const customerId = item.id;
    const customerOrgStepGroupId = this.selectedChecklist.id;

    this.customersNotUsing.push(item);
    this.customersNotUsing = [...this.customersNotUsing.sort((a, b) => (a.name > b.name ? 1 : -1))]; // Dereference it to trigger update
    this.customersUsing = this.customersUsing.filter((x) => x.id != item.id);
    this.organisationSpecificStepService
      .removeChecklistClone(customerOrgStepGroupId, customerId)
      .then(() => {});
  }
}
